import { Helmet } from 'react-helmet';
import WelcomeComponent from './welcomeComponent';
export interface ImainComponentProps {
}

const MainComponent: React.FunctionComponent<ImainComponentProps> = (props: ImainComponentProps) => {

    return (
        <>
            <Helmet>
                <title>{"Switch modding service"}</title>
                <meta property="og:image" content={`/assets/metalogo.webp?v=${1}`} />
                <meta name="description" content="Laat uw switch modden of koop een kant en klaar model" />
                <meta name="keywords" content={"Nintendo, Switch, Lite, V1, V2, mod, modding, picofly, jailbreak, ombouwen"} />
                <meta name="author" content="Me" />
            </Helmet>

            <WelcomeComponent  />
        </>
    );
}

export default MainComponent;